import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const formCategoryImporterSelectors = importerSelectors(
  'formCategory.importer',
);

export default formCategoryImporterSelectors;
